import Vue from 'vue'
import * as types from '../mutation-types'

const state = {
  tablet: false,
  phone: false,
  isMobile: false
}

const getters = {
  getPhone: state => state.phone,
  getTablet: state => state.tablet,
  getIsMobile: state => state.isMobile
}

const actions = {}

const mutations = {
  [types.UPDATE_APP] (state, { field, value }) {
    Vue.set(state, field, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
